<template>
        <el-card style="width: 100%">
            <div
                    slot="header"
                    class="clearfix"
            >
                <span>Vevői eladások és visszáruk</span>
            </div>
            <div class="filter-container">
                <el-form
                        label-position="top"
                >
                    <el-row :gutter="20">
                        <el-col :span="16" style="display: flex; ">
                            <el-form-item
                                    label="Dátum"
                            >
                                <el-date-picker
                                        v-model="dateRange"
                                        type="daterange"
                                        :clearable="false"
                                        format="yyyy. MM. dd."
                                        value-format="yyyy-MM-dd"
                                        :picker-options="dateRangeOptions"
                                        style="margin-right: 10px;"
                                        @change="handleChange"
                                />
                            </el-form-item>
                            <el-form-item style="margin-right: 10px;"
                                          label="Vevő"
                            >
                                <el-select
                                    v-model="customer"
                                    filterable
                                    remote
                                    :remote-method="searchPartner"
                                    :loading="partnerLoading"
                                    placeholder="Gépelj a kereséshez..."
                                    style="width: 100%;"
                                    value-key="id"
                                    @change="handleChange"
                                    clearable
                                >
                                    <el-option
                                        v-for="p in partners"
                                        :key="p.company.id"
                                        :value="p"
                                        :label="p.company.name"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-col>
                      <el-col :span="8">
                        <el-row type="flex" justify="end"  style="text-align: right; margin-top: 24px;">
                          <el-button
                            :loading="downloadLoading"
                            icon="el-icon-download"
                            @click="download"
                          >
                            Letöltés
                          </el-button>
                          <el-button
                            :loading="printLoading"
                            icon="el-icon-printer"
                            @click="print"
                          >
                            Nyomtatás
                          </el-button>
                        </el-row>
                      </el-col>
                    </el-row>
                </el-form>
            </div>

            <div v-loading="loading">
                <el-table
                        :data="data.data"
                        style="width: 100%"
                        row-key="id"
                        border
                >
                    <el-table-column
                            prop="count"
                            label="Teljesítés"
                            width="100"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.date }}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="receipt_number"
                            label="Szállítólevél száma"
                            width="130"

                    >
                    </el-table-column>

                    <el-table-column
                            prop="invoice_number"
                            label="Számla"
                            width="130"
                    >
                    </el-table-column>


                    <el-table-column
                        prop="name"
                        label="Termék"
                        show-overflow-tooltip
                        width="200"

                    >
                    </el-table-column>

                    <el-table-column
                        prop="count"
                        label="Mennyiség (db)"
                        align="right"
                        width="150"
                    >
                    </el-table-column>

                    <el-table-column
                        prop="unit_price"
                        label="Egységár (szál.lev.)"
                        align="right"
                        width="150"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.unit_price | currency }}
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="net_price"
                        label="Nettó (szál.lev.)"
                        align="right"
                        width="150"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.net_price | currency }}
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="vat"
                        label="Áfakulcs (szál.lev.)"
                        align="right"
                        width="150"
                    >
                    </el-table-column>

                    <el-table-column
                        prop="invoice_unit_price"
                        label="Egységár (számla)"
                        align="right"
                        width="150"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.invoice_unit_price | currency }}
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="invoice_net_price"
                        label="Nettó (számla)"
                        align="right"
                        width="150"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.invoice_net_price | currency }}
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="invoice_vat"
                        label="Áfakulcs (számla)"
                        align="right"
                        width="150"
                    >
                    </el-table-column>

                </el-table>

                <div class="el-card-footer">
                    <el-pagination
                        background
                        :current-page="currentPage"
                        :page-sizes="[20, 50, 100, 200]"
                        :page-size="data.per_page"
                        layout="total, prev, pager, next"
                        :total="data.total"
                        @current-change="handleCurrentChange"
                    />
                </div>
            </div>
        </el-card>
</template>

<script>
    import moment from 'moment';
    import { saveAs } from 'file-saver';


    export default {
        components: {
        },
        data() {
            const start = moment()
                .startOf('year')
                .format('Y-MM-DD');
            const end = moment()
                .format('Y-MM-DD');
            return {
                data: {},
                currentPage: 1,
                loading: false,
                downloadLoading: false,
                partners: [],
                customer: null,
                supplier: null,
                partnerLoading: false,
                printLoading: false,
                dateRange: [start, end],
                dateRangeOptions: {
                    firstDayOfWeek: 1,
                    shortcuts: [{
                        text: 'Aktuális hét',
                        onClick(picker) {
                            const start = moment()
                                .weekday(1)
                                .toDate();
                            const end = moment()
                                .weekday(7)
                                .toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: 'Előző hét',
                        onClick(picker) {
                            const start = moment()
                                .subtract({weeks: 1})
                                .weekday(1)
                                .toDate();
                            const end = moment()
                                .subtract({weeks: 1})
                                .weekday(7)
                                .toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: 'Aktuális hónap',
                        onClick(picker) {
                            const start = moment()
                                .startOf('month')
                                .toDate();
                            const end = moment()
                                .endOf('month')
                                .toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: 'Előző hónap',
                        onClick(picker) {
                            const start = moment()
                                .subtract({months: 1})
                                .startOf('month')
                                .toDate();
                            const end = moment()
                                .subtract({months: 1})
                                .endOf('month')
                                .toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: 'Előző 3 hónap',
                        onClick(picker) {
                            const start = moment()
                                .subtract({months: 3})
                                .startOf('month')
                                .toDate();
                            const end = moment()
                                .subtract({months: 1})
                                .endOf('month')
                                .toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: 'Aktuális év',
                        onClick(picker) {
                            const start = moment()
                                .startOf('year')
                                .toDate();
                            const end = moment()
                                .endOf('year')
                                .toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: 'Előző év',
                        onClick(picker) {
                            const start = moment()
                                .subtract({years: 1})
                                .startOf('year')
                                .toDate();
                            const end = moment()
                                .subtract({years: 1})
                                .endOf('year')
                                .toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: 'YTD',
                        onClick(picker) {
                            const start = moment()
                                .startOf('year')
                                .toDate();
                            const end = moment()
                                .toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: 'MTD',
                        onClick(picker) {
                            const start = moment()
                                .startOf('month')
                                .toDate();
                            const end = moment()
                                .toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
            };
        },
        computed: {

        },
        watch: {},
        async mounted() {
            this.fetchData();
        },
        methods: {
            async download() {
                this.downloadLoading = true;
                try {
                    const excel = await axios({
                        url: `api/reports/customer-sale-and-return/download`,
                        method: 'POST',
                        responseType: 'blob',
                        data: {
                            from: this.dateRange[0],
                            to: this.dateRange[1],
                            customer_id: this.customer ? this.customer.id : null,
                        },
                    });
                    saveAs(excel, `customersaleandreturn.xlsx`);
                } catch (e) {}
                this.downloadLoading = false;
            },

            async fetchData() {
                this.loading = true;
                let query = `api/reports/customer-sale-and-return?page=${this.currentPage}&from=${this.dateRange[0]}&to=${this.dateRange[1]}`

                if (this.customer) {
                    query += `&customer_id=${this.customer.id}`
                }

                this.data = await axios.get(query);
                this.loading = false;
            },

            async searchPartner(query) {
                if (query !== '') {
                    this.partnerLoading = true;
                    this.partners = await this.$store.dispatch('partner/search', '?name=' + query + '&is_supplier=true');
                    this.partnerLoading = false;
                }
            },

            handleChange() {
                this.currentPage = 1;
                this.fetchData();
            },

            handleCurrentChange(val) {
                this.currentPage = val;
                this.fetchData();
            },

          async print() {
            this.printLoading = true;
            const response = await axios.post('api/reports/customer-sale-and-return/print', {
              from: this.dateRange[0],
              to: this.dateRange[1],
              customer_id: this.customer ? this.customer.id : null,
            }, {
              responseType: 'arraybuffer',
              headers: {
                'Accept': 'application/pdf'
              },
            });
            this.printLoading = false;

            const newBlob = new Blob([response], {type: 'application/pdf'});
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(newBlob);
              return;
            }

            const data = window.URL.createObjectURL(newBlob);
            window.open(data);
          },

        },
    };
</script>
<style lang="scss">
    .stockValue-table {
        .el-table__footer {
            td {
                .cell {
                    font-weight: 700;
                }
            }
        }
    }
</style>
